<div class="wrapper-product-card">
  <div class="header-row"></div>
  <div class="wrapper-content">
    <div class="first-row">
      <div class="wrapper-image">
        <ngx-skeleton-loader
          [theme]="{height: '88px', width: '88px', 'border-radius':'0'}"
          appearance="circle"
        ></ngx-skeleton-loader>
      </div>
      <div class="wrapper-content">
        <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
        <div class="wrapper-product-attributes">
          <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper-skeleton-footer">
    <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
  </div>
</div>
